var React = require('react');

function Q3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Q3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M60.31,12.14A39.1,39.1,0,0,0,9,7.44L61.87,64.31A39.1,39.1,0,0,0,60.31,12.14Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M76.89,74.28,42.52,42.92h0L8.27,11.43l-.56.75A40,40,0,0,0,43.9,75.61v.06Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Q3.defaultProps = {"viewBox":"0 0 76.89 75.8"};

module.exports = Q3;

Q3.default = Q3;
